import React, { useState, useEffect } from 'react';
import HeadingArea from '../general/HeadingArea';
import ResponseMsg2 from '../general/ResponseMsg2';
import { AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import { MdOutlineEdit } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';

const AcademicYear = ({ setLoading }) => {
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
const [formData, setFormData] = useState({
  year: '',
  title: '',
  start: '',
  end: ''
});
const [academicYears, setAcademicYears] = useState([]);
const [editYearId, setEditYearId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
const [searchTerm, setSearchTerm] = useState('');
  const [selectedAY, setSelectedAY] = useState({});
  const [showDelete, setShowDelete] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const handleEdit = (year) => {
  setFormData({
    year: year.year,
    title: year.title,
    start: year.start,
    end: year.end
  });
  setEditYearId(year.id);
  setIsEditMode(true);
};


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.year || !formData.title || !formData.start || !formData.end) {
    setResponse2({ message: 'Please fill all fields.', status: 'error' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    return;
  }

  setLoading(true);

  try {
    const url = editYearId
      ? `https://api.kcian.in/update-academic-year/${editYearId}`
      : 'https://api.kcian.in/add-academic-year';

    const method = editYearId ? 'PUT' : 'POST';

    const res = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const result = await res.json();

    if (res.ok) {
      fetchAcademicYears();
      setResponse2({ message: result.message || (editYearId ? 'Academic Year updated!' : 'Academic Year added!'), status: 'success' });
      setFormData({ year: '', title: '', start: '', end: '' });
      setIsEditMode(false);
      setEditYearId(null);
    } else {
      setResponse2({ message: result.message || 'Something went wrong. Try Later.', status: 'error' });
    }
  } catch (err) {
    console.error(err);
    setResponse2({ message: 'Server error occurred.', status: 'error' });
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};


const fetchAcademicYears = async () => {
  setLoading(true);
  try {
    const response = await fetch('https://api.kcian.in/get-academic-years');

    if (response.ok) {
      const data = await response.json();
      setAcademicYears(data);
    } else {
      console.error('Failed to fetch academic years');
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setLoading(false);
  }
};

  
      useEffect(() => {
          fetchAcademicYears();
      }, []);
  

  const filteredAY = academicYears.filter(ay => {
  const term = searchTerm.toLowerCase();
  return (
    ay.year.toLowerCase().includes(term) ||
        ay.title.toLowerCase().includes(term)
  );
});


    const handleShowDelete = (cls) => {
    setSelectedAY(cls);
    setShowDelete(true);
  }


              const handleDelete = async (ayId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-academic-year/${ayId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setAcademicYears((prevData) => prevData.filter((product) => product.id !== ayId));
        setShowDelete(false);
        setResponse2({ message: 'Academic Year Removed!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting AY:', error);
    }
  };



  return (
    <>
    <section className="py-4">
      <div className="px-4">
          <HeadingArea message1='General Settings' message2='Academic Year' />

        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

        <div className='row'>
          <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
            <div className="profile-card">
              <p className="profile-heading">Add Academic Year</p>

<form className='mt-4' onSubmit={handleSubmit}>
  <div className="profile-input-area mb-4">
    <label className="profile-badge">Academic Year*</label>
    <input
      type="text"
      name="year"
      value={formData.year}
      onChange={handleChange}
      className="profile-input"
      placeholder="e.g. 2023"
      required
    />
  </div>

  <div className="profile-input-area mb-4">
    <label className="profile-badge">Year Title*</label>
    <input
      type="text"
      name="title"
      value={formData.title}
      onChange={handleChange}
      className="profile-input"
      placeholder="e.g. Term 2023-24"
      required
    />
  </div>

  <div className="profile-input-area mb-4">
    <label className="profile-badge">Start Date*</label>
    <input
      type="date"
      name="start"
      value={formData.start}
      onChange={handleChange}
      className="profile-input"
      required
    />
  </div>

  <div className="profile-input-area mb-4">
    <label className="profile-badge">End Date*</label>
    <input
      type="date"
      name="end"
      value={formData.end}
      onChange={handleChange}
      className="profile-input"
      required
    />
  </div>

  <div className='text-center'>
    <button type="submit" className="profile-btn me-2">
      {isEditMode ? <><AiOutlineEdit /> Update</> : <><AiOutlinePlus /> Add</>}
    </button>

    {isEditMode && (
      <button
        type="button"
        className="profile-btn2"
        onClick={() => {
          setFormData({ year: '', title: '', start: '', end: '' });
          setIsEditMode(false);
          setEditYearId(null);
        }}
      >
        Cancel
      </button>
    )}
  </div>
</form>

            </div>
          </div>
{/* left ends */}


<div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
<div className='profile-card'>

  <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
            <span className="profile-heading align-content-center">AY List</span>


                  <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search Year, Title'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>
  </div>

<div className='table-responsive'>
<table className='w-100'>
  <thead className='account-thead'>
    <tr>
      <th className='rounded-start-4'>S No</th>
      <th>Year</th>
      <th>Title</th>
      <th>Start</th>
      <th>End</th>
      <th className='rounded-end-4'>Action</th>
    </tr>
  </thead>
  <tbody>
    {filteredAY.map((year, index) => (
      <tr className='account-tr' key={year.id}>
        <td>{index + 1}</td>
        <td>{year.year}</td>
        <td>{year.title}</td>
        <td>{year.start}</td>
        <td>{year.end}</td>
        <td>
          <MdOutlineEdit className='account-icon1' onClick={() => handleEdit(year)} />
          &nbsp;&nbsp;
          <RiDeleteBin6Line className='account-icon2' onClick={() => handleShowDelete(year)} />
        </td>
      </tr>
    ))}
  </tbody>
</table>

</div>
{/* table ends */}



</div>
</div>
{/* right ends */}

        </div>
{/* row ends */}

      </div>
    </section>
    
          {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Academic Year!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
      <th className='rounded-start-4'>Year</th>
      <th>Title</th>
      <th>Start</th>
      <th className='rounded-end-4'>End</th>
</thead>

<tr className='account-tr'>
<td>{selectedAY.year}</td>
<td>{selectedAY.title}</td>
<td>{selectedAY.start}</td>
<td>{selectedAY.end}</td>
</tr>

</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Academic Year will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedAY.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}
    </>
  );
};

export default AcademicYear;
